import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sensorsMain"
}
const _hoisted_2 = { class: "sensorsMain-container-general" }
const _hoisted_3 = { class: "sensorsMain-sensor" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = {
  key: 1,
  class: "value"
}
const _hoisted_6 = {
  key: 0,
  class: "sensorsMain-diagram"
}
const _hoisted_7 = { class: "sensorsMain-sensorInfo" }
const _hoisted_8 = {
  key: 0,
  class: "checkedSensor"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  key: 0,
  class: "sensorsMain-container-alarmsTable"
}
const _hoisted_13 = { class: "sensorsMain-container-alarmsTable__title" }
const _hoisted_14 = {
  key: 1,
  class: "sensorsMain"
}
const _hoisted_15 = { class: "sensorsMain-diagram" }
const _hoisted_16 = {
  key: 0,
  class: "sensorsMain-container-alarmsTable"
}
const _hoisted_17 = { class: "sensorsMain-container-alarmsTable__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_EditSensor = _resolveComponent("EditSensor")!
  const _component_AddComment = _resolveComponent("AddComment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedOption?.[0]?.value !== 'all')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSensorsData, (el) => {
            return (_openBlock(), _createElementBlock("div", {
              key: el.id,
              class: "sensorsMain-container"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoAboutSersor, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "sensorsMain-sensor-info"
                    }, [
                      (el[item.value])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.label), 1))
                        : _createCommentVNode("", true),
                      (el[item.value])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(el[item.value]), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (_ctx.chartDataById(el.sn)?.labels?.length && _ctx.isDateCorrect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(), _createBlock(_component_LineChart, {
                        id: 'lineChart_' + el.sn,
                        key: _ctx.lineChartKey,
                        "data-line-chart": _ctx.chartDataById(el.sn),
                        "options-line-chart": _ctx.optionsLineChart,
                        style: _normalizeStyle(_ctx.styleLineChart)
                      }, null, 8, ["id", "data-line-chart", "options-line-chart", "style"]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.temperatureSensorStamp?.timestamp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_Checkbox, {
                          name: "checkedSensor",
                          value: _ctx.checkedSensor
                        }, null, 8, ["value"]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.temperatureSensorStamp.userName), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.dateTime(_ctx.temperatureSensorStamp.timestamp)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    class: "editSensor-button",
                    variant: "filled",
                    title: _ctx.$t('editSensor'),
                    onClick: ($event: any) => (_ctx.initEditSensor(el.id))
                  }, null, 8, ["title", "onClick"]),
                  _createVNode(_component_Button, {
                    class: "comment-button",
                    variant: "filled",
                    title: _ctx.$t('comment'),
                    onClick: ($event: any) => (_ctx.initComment(el.id))
                  }, null, 8, ["title", "onClick"])
                ])
              ]),
              (_ctx.tableDataById(el.id)?.length && _ctx.isDateCorrect)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('deviationsInTimeFrame')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Table, {
                        data: _ctx.tableDataById(el.id),
                        columns: _ctx.columnsById
                      }, null, 8, ["data", "columns"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedOption?.[0]?.value === 'all' && _ctx.isDateCorrect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createBlock(_component_LineChart, {
              id: 'lineChart',
              key: _ctx.lineChartKey,
              "data-line-chart": _ctx.dataLineChart,
              "options-line-chart": _ctx.optionsLineChart,
              style: _normalizeStyle(_ctx.styleLineChart)
            }, null, 8, ["data-line-chart", "options-line-chart", "style"]))
          ]),
          (_ctx.alarmsSensor.length && _ctx.isDateCorrect)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('deviationsInTimeFrame')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Table, {
                    data: _ctx.alarmsSensor,
                    columns: _ctx.columns
                  }, null, 8, ["data", "columns"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EditSensor, {
      "edit-sensor-data": _ctx.editSensorData,
      "pharmacy-id": _ctx.pharmacy?.id,
      "show-modal-edit-sensor": _ctx.showModalEditSensor,
      onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalEditSensor = false))
    }, null, 8, ["edit-sensor-data", "pharmacy-id", "show-modal-edit-sensor"]),
    _createVNode(_component_AddComment, {
      "edit-sensor-data": _ctx.editSensorData,
      "pharmacy-id": _ctx.pharmacy?.id,
      "show-modal-add-comment": _ctx.showModalAddComment,
      onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalAddComment = false))
    }, null, 8, ["edit-sensor-data", "pharmacy-id", "show-modal-add-comment"])
  ], 64))
}